var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card modal-card--md" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [_vm._v(" Compare ")]),
      _c(
        "a",
        {
          staticClass: "close-modal",
          attrs: { "aria-label": "close" },
          on: {
            click: function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _c("section", { staticClass: "modal-card-body" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }